// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function CultivationTargetsTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Cultivation Targets</p>
      <p>
        Build set point schemas for environment and substrate variables — by phase or as a single
        static table — and save them for your facility.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Name your schema and choose phase mode or a flat set point table.</li>
          <li>Select variables (VWC, EC, temp, RH, DLI, etc.) to include.</li>
          <li>Enter min/target/max set points per phase, then save or export.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Key features</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Manage Schemas — load, duplicate, and version saved target tables</li>
          <li>Export to CSV or PNG for SOPs and room signage</li>
          <li>Start grows from a schema to schedule phase timelines</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Saved schemas drive target-vs-actual compare in Aura and crop phase tracking.
      </p>
    </div>
  );
}
